/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentPlan } from './PaymentPlan';
import {
    PaymentPlanFromJSON,
    PaymentPlanFromJSONTyped,
    PaymentPlanToJSON,
} from './PaymentPlan';
import type { PaymentPlanMarketing } from './PaymentPlanMarketing';
import {
    PaymentPlanMarketingFromJSON,
    PaymentPlanMarketingFromJSONTyped,
    PaymentPlanMarketingToJSON,
} from './PaymentPlanMarketing';

/**
 * 
 * @export
 * @interface ClinicPaymentPlan
 */
export interface ClinicPaymentPlan {
    /**
     * 
     * @type {string}
     * @memberof ClinicPaymentPlan
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicPaymentPlan
     */
    tenant_id?: string;
    /**
     * 
     * @type {PaymentPlan}
     * @memberof ClinicPaymentPlan
     */
    payment_plan?: PaymentPlan;
    /**
     * Who can see this plan on the subscribe screen. Plans without a record (or with visibility absent) are treated as hidden, so newly created Stripe plans never leak to patients before ops configures them.
     * @type {string}
     * @memberof ClinicPaymentPlan
     */
    visibility?: ClinicPaymentPlanVisibilityEnum;
    /**
     * Marks the plan card as highlighted ("most popular") on the subscribe screen.
     * @type {boolean}
     * @memberof ClinicPaymentPlan
     */
    highlight?: boolean;
    /**
     * Minimum commitment in months. Only meaningful on month-interval plans. Absent or 0 disables the commitment period and contract-signing featureset for this plan.
     * @type {number}
     * @memberof ClinicPaymentPlan
     */
    minimum_months?: number;
    /**
     * Display bullets for the plan card on the subscribe screen.
     * @type {Array<string>}
     * @memberof ClinicPaymentPlan
     */
    features?: Array<string>;
    /**
     * Practitioner skills a patient on this plan is entitled to book. Any skill listed on any plan becomes restricted to patients whose current plan lists it; practitioners carrying a restricted skill are shown locked to everyone else.
     * @type {Array<string>}
     * @memberof ClinicPaymentPlan
     */
    unlocks_skills?: Array<string>;
    /**
     * Keeps the plan on the subscribe screen but stops new sign-ups. Subscribing is refused unless the patient already holds a price of the same Stripe product (so existing members can still switch between monthly and annual). Existing subscriptions are untouched.
     * @type {boolean}
     * @memberof ClinicPaymentPlan
     */
    closed_to_new_members?: boolean;
    /**
     * Patient-facing text shown on a closed plan card and returned when a subscribe is refused. Absent = a generic "not accepting new members" line naming the plan.
     * @type {string}
     * @memberof ClinicPaymentPlan
     */
    closed_message?: string;
    /**
     * 
     * @type {PaymentPlanMarketing}
     * @memberof ClinicPaymentPlan
     */
    marketing?: PaymentPlanMarketing;
}


/**
 * @export
 */
export const ClinicPaymentPlanVisibilityEnum = {
    Public: 'public',
    Internal: 'internal',
    Hidden: 'hidden'
} as const;
export type ClinicPaymentPlanVisibilityEnum = typeof ClinicPaymentPlanVisibilityEnum[keyof typeof ClinicPaymentPlanVisibilityEnum];


/**
 * Check if a given object implements the ClinicPaymentPlan interface.
 */
export function instanceOfClinicPaymentPlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ClinicPaymentPlanFromJSON(json: any): ClinicPaymentPlan {
    return ClinicPaymentPlanFromJSONTyped(json, false);
}

export function ClinicPaymentPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicPaymentPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'payment_plan': !exists(json, 'payment_plan') ? undefined : PaymentPlanFromJSON(json['payment_plan']),
        'visibility': !exists(json, 'visibility') ? undefined : json['visibility'],
        'highlight': !exists(json, 'highlight') ? undefined : json['highlight'],
        'minimum_months': !exists(json, 'minimum_months') ? undefined : json['minimum_months'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'unlocks_skills': !exists(json, 'unlocks_skills') ? undefined : json['unlocks_skills'],
        'closed_to_new_members': !exists(json, 'closed_to_new_members') ? undefined : json['closed_to_new_members'],
        'closed_message': !exists(json, 'closed_message') ? undefined : json['closed_message'],
        'marketing': !exists(json, 'marketing') ? undefined : PaymentPlanMarketingFromJSON(json['marketing']),
    };
}

export function ClinicPaymentPlanToJSON(value?: ClinicPaymentPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'payment_plan': PaymentPlanToJSON(value.payment_plan),
        'visibility': value.visibility,
        'highlight': value.highlight,
        'minimum_months': value.minimum_months,
        'features': value.features,
        'unlocks_skills': value.unlocks_skills,
        'closed_to_new_members': value.closed_to_new_members,
        'closed_message': value.closed_message,
        'marketing': PaymentPlanMarketingToJSON(value.marketing),
    };
}

